import { SERVER } from '../services/sendRequestAPI'

export function getImageAPI(url) {
	return SERVER + url
}